<template>
  <WebhookForm :id="id" :initial="effectiveInitial" :visibility-config="visibilityConfig" @saved="$emit('saved')">
    <template #parameters="{ getSecret, setSecret, getParam, setParam }">
      <div class="box">
        <h2 class="subtitle">{{ $t('openweather.settings') }}</h2>

        <BFieldHint :label="$t('openweather.latitude')" hintKey="">
          <b-input
            type="number"
            step="any"
            :model-value="getParam('LATITUDE')"
            :placeholder="$t('openweather.latitudePlaceholder')"
            @update:model-value="val => setParam('LATITUDE', val)"
          />
        </BFieldHint>

        <BFieldHint :label="$t('openweather.longitude')" hintKey="">
          <b-input
            type="number"
            step="any"
            :model-value="getParam('LONGITUDE')"
            :placeholder="$t('openweather.longitudePlaceholder')"
            @update:model-value="val => setParam('LONGITUDE', val)"
          />
        </BFieldHint>

        <BFieldHint :label="$t('openweather.apiKey')" hintKey="">
          <b-select :model-value="getSecret('OPENWEATHER_API_KEY')"
                    :placeholder="$t('openweather.selectSecret')"
                    @update:model-value="val => setSecret('OPENWEATHER_API_KEY', String(val))">
            <option v-for="name in secretOptions" :key="name" :value="name">{{ name }}</option>
          </b-select>
        </BFieldHint>
      </div>
    </template>
  </WebhookForm>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import WebhookForm from '@/views/templates/WebhookForm.vue'
import BFieldHint from '@/components/BFieldHint.vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'OpenWeatherForm',
  components: { WebhookForm, BFieldHint },
  props: {
    id: String,
    initial: Object as PropType<Record<string, unknown>>
  },
  emits: ['saved'],
  setup(props) {
    const store = useStore()
    const secretOptions = computed<string[]>(() => {
      const s: any = store.state.secrets || []
      const list = Array.isArray(s) ? s : Object.values(s)
      return list.map((x: any) => String(x.name)).filter(Boolean)
    })

    const defaultInitial = {
      name: '',
      event: 'openweather-data',
      template: 'openweather',
      url: 'http://api.openweathermap.org/data/3.0/onecall',
      requestType: 'GET',
      noDefaults: true,
      rejectUnauthorized: true,
      unchunked: false,
      data_url_response_event: false,
      query: {
        exclude: 'minutely,hourly,daily,alerts',
        lat: '{{{LATITUDE}}}',
        lon: '{{{LONGITUDE}}}',
        appid: '{{{OPENWEATHER_API_KEY}}}'
      },
      responseTemplate: '{ {{#current}}"temp":{{temp}}{{#weather}},"icon":"{{icon}}","id":{{id}}{{/weather}}{{/current}} }'
    } as Record<string, unknown>

    const effectiveInitial = computed<Record<string, unknown>>(() => {
      return (props.initial as any) || defaultInitial
    })
    
    const visibilityConfig = {
      jsonTab: false,
      secrets: false,
      requestURL: false,
      requestType: false,
      requestFormat: false,
      queryParams: false,
      httpHeaders: false,
      httpBasicAuth: false,
      responseTemplate: false
    }
    
    return { secretOptions, effectiveInitial, visibilityConfig }
  }
})
</script>
